import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        // Binding
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$el = this.el
        
        // Data
        this.productID = this.getData('id')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$el.addEventListener('click', this.onClickBind)
    }

    unbindEvents() {
        this.$el.removeEventListener('click', this.onClickBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick() {
        this.addToCart()
    }

    ///////////////
    // Methods
    ///////////////
    addToCart() {
        /////////////////////
        // Global ID
        // https://github.com/Shopify/mobile-buy-sdk-ios/issues/663#issuecomment-311369782
        // https://community.shopify.com/c/Shopify-APIs-SDKs/Getting-Global-ID/td-p/520191
        /////////////////////
        const baseGlobalId = `gid://shopify/ProductVariant/${this.productID}`
        const gid = btoa(baseGlobalId)

        this.call('addItem', {
            "id": this.productID,
            "quantity": 1
        }, 'Cart')
    }
}
